import axiosClient from '@services/axiosClient';

export const dataUrlToFile = async (
  dataUrl: string,
  fileName: string,
): Promise<File> => {
  try {
    const proxyUrl = 'https://proxy.cors.sh'; // cors-anywhere proxy
    const proxiedDataUrl = `${proxyUrl}/${dataUrl}`;

    const response = await axiosClient.get(proxiedDataUrl, {
      responseType: 'blob',
    });
    const blob = response.data;
    return new File([blob], fileName, { type: 'image/png' });
  } catch (error) {
    console.error('Error fetching remote resource:', error);
    throw error; // Rethrow the error to handle it higher up in the call stack
  }
};

export const compareFiles = async (
  file1: File,
  file2: File,
): Promise<boolean> => {
  if (file1.size !== file2.size) {
    return false;
  }

  const content1 = await fileToUint8Array(file1);
  const content2 = await fileToUint8Array(file2);

  return content1.every((byte, index) => byte === content2[index]);
};

const fileToUint8Array = async (file: File): Promise<Uint8Array> =>
  await new Promise<Uint8Array>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.result instanceof ArrayBuffer) {
        resolve(new Uint8Array(reader.result));
      } else {
        console.warn('Error reading file as ArrayBuffer');
      }
    };
    reader.onerror = () => {
      console.warn('Error reading file');
    };
    reader.readAsArrayBuffer(file);
  });

export const fetchFileFromURL = async (
  url: string,
  filename: string,
  mimeType: string,
): Promise<File> => {
  const response = await fetch(url);
  const blob = await response.blob();
  return new File([blob], filename, { type: mimeType });
};
